module.exports = __webpack_public_path__ + "media/images/icons/large-arrow-down-right-c5d3563556d29ff97a5f70b760cbfdbc.svg";